import { Component, ComponentRef, inject, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { StateService } from '../../services/state-service';
import { IDialogConfig } from '../../model/DialogConfig';
import { DialogService } from '../../services/dialog-service';

@Component({
  selector: 'app-dialog-box',
  imports: [DialogModule, ButtonModule],
  templateUrl: './dialog-box.html',
  styleUrl: './dialog-box.scss',
})
export class DialogBox implements OnInit {
  @ViewChild('container', { read: ViewContainerRef }) containerRef!: ViewContainerRef;

  stateService = inject(StateService);
  private dialogService = inject(DialogService)

  visible = false;
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  header: string = ''
  width: string = '';
  closable: boolean = true;
  private closeCallback?: (result: unknown) => void;
  private componentRef: ComponentRef<unknown> | null = null;
  customClass?: string = '';
  showHeader?: boolean = true;
  minwidth: string = ''

  ngOnInit(): void {
    this.dialogService.register(this);
  }

  open<TComponent, TData = unknown, TResult = unknown>(
    component: Type<TComponent>,
    config: IDialogConfig<TData> = {}
  ): Promise<TResult | undefined> {
    this.header = config.header ?? '';
    this.width = config.width ?? '25rem';
    this.position = config.position ?? 'center';
    this.closable = config.closable ?? true;
    this.customClass = config.customClass;
    this.showHeader = config.showHeader;
    this.visible = true;
    this.minwidth = config.minwidth ?? '280px'

    // Wait one tick for the dialog to render before stamping the component
    setTimeout(() => this.mountComponent(component, config.data));

    return new Promise<TResult | undefined>((resolve) => {
      this.closeCallback = resolve as (result: unknown) => void;
    });
  }


  close(result?: unknown) {
    this.visible = false;
    this.closeCallback?.(result);
    this.destroyComponent();
  }


  onDialogHide() {
    // Handles the X button / backdrop click
    this.closeCallback?.(undefined);
    this.destroyComponent();
  }


  private mountComponent<TComponent>(
    component: Type<TComponent>,
    data?: unknown
  ) {
    this.containerRef.clear();
    this.componentRef = this.containerRef.createComponent(component);

    // ✅ Pass data and a close handle into the injected component
    const instance = this.componentRef.instance as Record<string, unknown>;
    if (data !== undefined) instance['data'] = data;
    instance['dialogClose'] = (result: unknown) => this.close(result);

    this.componentRef.changeDetectorRef.detectChanges();
  }


  private destroyComponent() {
    this.componentRef?.destroy();
    this.componentRef = null;
    this.containerRef?.clear();
  }

}
